import type { ReactNode } from 'react';
import QuestionMarkTooltip from '../../QuestionMarkTooltip';

export interface StatCardProps {
  title: string;
  stat: number | string | React.ReactNode;
  icon?: ReactNode;
  toolTip?: string;
}

export default function StatCard(props: StatCardProps) {
  const { title, stat, icon, toolTip } = props;

  return (
    <div className='bg-white rounded-md flex flex-row p-4 relative h-full border border-gray-200'>
      <div className='flex-grow flex flex-col justify-between gap-2 font-bold'>
        <div className='flex gap-3'>
          <span className='text-md'>{title}</span>
          <div>{toolTip && <QuestionMarkTooltip toolTip={toolTip} />}</div>
        </div>
        <span className='text-primaryColor-normal text-xl w-full '>{stat}</span>
      </div>
      {icon && <div className='p-1'>{icon}</div>}
    </div>
  );
}
